/**
 * Aviso flutuante — o "toast" do esboço.
 *
 * Confirma que algo aconteceu sem tirar a pessoa de onde ela está. É o retorno
 * da solicitação de acesso: sem ele, clicar em "Enviar" fecha o painel e nada
 * indica que o pedido foi registrado.
 *
 * ## Por que um barramento e não estado numa tela
 *
 * Quem dispara o aviso é o painel de detalhe; quem o desenha é a moldura, que
 * fica por fora. Passar a função de mão em mão por três níveis de componente
 * acopla telas que não têm relação nenhuma entre si.
 *
 * `role="status"` e `aria-live="polite"` fazem o leitor de tela anunciar a
 * mensagem quando ela chega — sem interromper o que estiver sendo lido.
 */
import { useEffect, useState } from 'react';

const listeners = new Set();

/** Dispara um aviso de qualquer lugar da aplicação. */
export function notify(text, kind = 'sucesso') {
  for (const listener of listeners) listener({ text, kind, id: Date.now() });
}

const DURATION_MS = 5000;

export function Toast() {
  const [notice, setNotice] = useState(null);

  useEffect(() => {
    listeners.add(setNotice);
    return () => {
      listeners.delete(setNotice);
    };
  }, []);

  useEffect(() => {
    if (!notice) return undefined;
    const t = setTimeout(() => setNotice(null), DURATION_MS);
    return () => clearTimeout(t);
  }, [notice]);

  if (!notice) return null;

  return (
    <div className={`toast ${notice.kind}`} role="status" aria-live="polite">
      <span>{notice.text}</span>
      <button
        type="button"
        className="toast-close"
        onClick={() => setNotice(null)}
        aria-label="Fechar aviso"
      >
        ×
      </button>
    </div>
  );
}
